import { render, staticRenderFns } from "./AttachmentsTable.vue?vue&type=template&id=bac5c7ac&"
import script from "./AttachmentsTable.vue?vue&type=script&lang=js&"
export * from "./AttachmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports